import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Header from './component/header/Header';
import Footer from './component/footer/Footer';
import Home from './component/pages/Home';
import About from './component/pages/About';
import BouncerBodyguard from './component/pages/SecurityServices/BouncerBodyguard';
import Escortguard from './component/pages/SecurityServices/Escortguard';
import EventSecurity from './component/pages/SecurityServices/EventSecurity';
import SchoolSecurity from './component/pages/SecurityServices/SchoolSecurity';
import SecurityGuard from './component/pages/SecurityServices/SecurityGuard';
import TouristSecurity from './component/pages/SecurityServices/TouristSecurity';
import EventStaff from './component/pages/ManpowerServices/EventStaff';
import FrontBackManpower from './component/pages/ManpowerServices/FrontBackManpower';
import TempStaffing from './component/pages/ManpowerServices/TempStaffing';
import HouseKeepingService from './component/pages/FacilityServices/HouseKeepingService';
import CanpactualService from './component/pages/FacilityServices/CanpactualService';
import OfficeBoy from './component/pages/FacilityServices/OfficeBoy';
import OfficeSupportService from './component/pages/FacilityServices/OfficeSupportService';
import PantryBoy from './component/pages/FacilityServices/PantryBoy';
import OurClient from './component/pages/OurClient';
import Gallery from './component/pages/Gallery';
import Contact from './component/pages/Contact';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import './App.css';

const App = () => {
    return (
        <>
         <ToastContainer />
            <BrowserRouter>
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/About" element={<About/>}/>
                    <Route path="/services/bouncer-and-bodyguard/" element={<BouncerBodyguard/>}/>
                    <Route path="/services/escort-guard/" element={<Escortguard/>}/>
                    <Route path="/services/event-security/" element={<EventSecurity/>}/>
                    <Route path="/services/school-security/" element={<SchoolSecurity/>}/>
                    <Route path="/services/security-guard/" element={<SecurityGuard/>}/>
                    <Route path="/services/tourist-security/" element={<TouristSecurity/>}/>
                    <Route path="/manpower-service/front-back-office-manpower/" element={<FrontBackManpower/>}/>
                    <Route path="/manpower-service/temporary-staffing-solution/" element={<TempStaffing/>}/>
                    <Route path="/manpower-service/event-staff/" element={<EventStaff/>}/>
                    <Route path="/facility-service/corporate-housekeeping-service/" element={<HouseKeepingService/>}/>
                    <Route path="/facility-service/office-boy/" element={<OfficeBoy/>}/>
                    <Route path="/facility-service/pantry-boy/" element={<PantryBoy/>}/>
                    <Route path="/facility-service/office-support-service" element={<OfficeSupportService/>}/>
                    <Route path="/facility-service/canpactual-staffing-driver" element={<CanpactualService/>}/>
                    <Route path="/our-clients" element={<OurClient/>}/>
                    <Route path="/gallery" element={<Gallery/>}/>
                    <Route path="/contact-us" element={<Contact/>}/>
                </Routes>
                <Footer />
            </BrowserRouter>
        </>
    )
}

export default App;
